var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFontDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 13,
    viewBox: "0 0 20 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3079 13H10.1041L8.84567 9.55985H3.46617L2.20514 13H0L4.95431 0H7.35356L12.3079 13ZM4.07093 7.90898H8.2409L6.21138 2.3616H6.10442L4.07093 7.90898Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8394 5.46112L16.3312 9.0073C16.1172 9.22367 15.77 9.22367 15.556 9.0073L12.0478 5.46103C11.8336 5.24462 11.8336 4.89381 12.0478 4.6774C12.1547 4.56924 12.2951 4.51511 12.4354 4.51511C12.5757 4.51511 12.7159 4.56924 12.823 4.6774L15.3954 7.27774V0.786025C15.3954 0.480027 15.6409 0.23192 15.9436 0.23192C16.2462 0.23192 16.4918 0.480027 16.4918 0.786025V7.27779L19.0642 4.67753C19.2783 4.46116 19.6254 4.46116 19.8394 4.67753C20.0535 4.8939 20.0535 5.24471 19.8394 5.46112Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFontDown);
export default __webpack_public_path__ + "static/media/FontDown.333efc59b421a9262d3a1f5e10c95ed4.svg";
export { ForwardRef as ReactComponent };